import axios from "axios";
import qs from "qs";

const CLIENT_ID = "webapp";
const CLIENT_SECRET = "6R79kVm63ZM9eJ25";

export function getServerToken({ username, password, provider }) {
  return axios({
    url: "/oauth/token",
    method: "POST",
    headers: {
      "content-type": "application/x-www-form-urlencoded",
    },
    data: qs.stringify({
      grant_type: "password",
      username,
      password,
      provider: provider,
    }),
    auth: {
      username: CLIENT_ID,
      password: CLIENT_SECRET,
    },
  });
}
export function setAuth(token) {
  axios.defaults.headers.common["Authorization"] = `bearer ${token}`;
}
export function getConfig() {
  return axios({
    url: "/api/config",
    method: "GET",
    auth: {
      username: CLIENT_ID,
      password: CLIENT_SECRET,
    },
  });
}
export function getLanguage(url) {
  let auth = axios.defaults.headers.common["Authorization"];
  delete axios.defaults.headers.common["Authorization"];
  let prom = axios({
    url,
    method: "GET",
  });
  axios.defaults.headers.common["Authorization"] = auth;
  return prom;
}
export function getRoles() {
  return axios({
    url: "/api/me/role",
    method: "GET",
  });
}
export function getUser() {
  return axios({
    url: "/api/me",
    method: "GET",
  });
}
export function getApplicationPreference(userId) {
  let url = "/api/applicationPreferences/search/findByUserId?userId=" + userId;
  return axios({
    url,
    method: "GET",
  });
}

export function signUp(userData) {
  return axios({
    url: "/api/signUp",
    method: "POST",
    data: userData,
  });
}
export function uploadProfilePicture(file) {
  var formData = new FormData();
  formData.append("file", file);
  formData.append("filename", file.name);
  return axios.post("/api/uploadprofilepic", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
export function uploadContactFile(file) {
  var formData = new FormData();
  formData.append("file", file);
  formData.append("filename", file.name);
  return axios.post("/api/uploadcontactfile", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function forgottenPassword(email, phone) {
  return axios({
    url: "/api/forgottenPassword",
    method: "POST",
    data: { email, phone },
  });
}

export function setNewPassword(token, newPassword) {
  return axios({
    url: "/api/setNewPassword",
    method: "POST",
    data: { token, newPassword },
  });
}

export function saveProfile(data) {
  return axios({
    url: "/api/me",
    method: "PUT",
    data,
  });
}
export function deleteProfile() {
  return axios({
    url: "/api/me",
    method: "DELETE",
  });
}

export function getGameReport(archive) {
  return axios({
    url: "/api/report/dashboard",
    params: {
      archive,
    },
    method: "GET",
  });
}

export function getPlans() {
  return axios({
    url: "/api/member/plans",
    method: "GET",
  });
}

export function requestMembershipUpgrade(planId, currency) {
  return axios({
    url: "/api/member/upgradeRequest",
    method: "POST",
    data: {
      planId,
      currency,
    },
  });
}
export function requestMembershipConfirm(password) {
  return axios({
    url: "/api/member/upgradeConfirm",
    method: "POST",
    data: {
      password,
    },
  });
}

export function getTechSkills() {
  return axios({
    url: "/api/skill/technical",
    method: "GET",
  });
}

export function getAllSportsTechSkills() {
  return axios({
    url: "/api/skill/technical/allsports",
    method: "GET",
  });
}

export function getTechCircleSkills() {
  return axios({
    url: "/api/skill/technical/circle",
    method: "GET",
  });
}

export function getTechIplayme2Skills() {
  return axios({
    url: "/api/skill/technical/iplayme2",
    method: "GET",
  });
}

export function getPersonalSkill() {
  return axios({
    url: "/api/skill/personal",
    method: "GET",
  });
}

export function getPersonalCircleSkill() {
  return axios({
    url: "/api/skill/personal/circle",
    method: "GET",
  });
}

export function getPersonalIplayme2Skill() {
  return axios({
    url: "/api/skill/personal/iplayme2",
    method: "GET",
  });
}

export function getIPlayme2SingleRank() {
  return axios({
    url: "/api/rank/iplayme2",
    method: "GET",
  });
}

export function getIPlayme2DoubleRank() {
  return axios({
    url: "/api/rank/iplayme2?double=true",
    method: "GET",
  });
}

export function getRatingHistory(teamId) {
  return axios({
    url: "/api/report/ratinghistory/" + teamId,
    method: "GET",
  });
}

export function setScoreGameAction(gameId, data) {
  return axios({
    url: `/api/game/${gameId}/action`,
    method: "PUT",
    data: { ...data, actionType: "SET_SCORE" },
  });
}

export function declineGameAction(gameId) {
  return axios({
    url: `/api/game/${gameId}/action`,
    method: "PUT",
    data: { actionType: "DECLINE" },
  });
}

export function setPartnerAction(gameId, contactId) {
  return axios({
    url: `/api/game/${gameId}/action`,
    method: "PUT",
    data: {
      actionType: "PARTNER_SELECTION",
      contactList: [{ id: contactId }],
    },
  });
}

export function sendGameAction(gameId, data) {
  return axios({
    url: `/api/game/${gameId}/action`,
    method: "PUT",
    data,
  });
}

export function selectLocationGameAction(gameId, data) {
  return axios({
    url: `/api/game/${gameId}/action`,
    method: "PUT",
    data: { ...data, actionType: "SELECT_LOCATION" },
  });
}
export function selectCalendarGameAction(gameId, data) {
  return axios({
    url: `/api/game/${gameId}/action`,
    method: "PUT",
    data: { ...data, actionType: "SELECT_CALENDAR" },
  });
}
export function getGameById(id) {
  return axios({
    url: `/api/game/${id}`,
    method: "GET",
  });
}
export function appEmailShare(emails) {
  return axios({
    url: "/api/share/emailShare",
    method: "POST",
    params: {
      emailsString: emails,
      comment: "",
    },
  });
}
export function ballsStatistics() {
  return axios({
    url: "/api/balls/statistics",
    method: "GET",
  });
}
export function getPublicProfile(token) {
  return axios({
    url: "/api/publicProfile/" + token,
    method: "GET",
    auth: {
      username: CLIENT_ID,
      password: CLIENT_SECRET,
    },
  });
}

export function postUnsubscribe(type, passwordRef, token) {
  return axios({
    url: "/api/unsubsribe",
    method: "POST",
    data: {
      type,
      passwordRef,
      token,
    },
    auth: {
      username: CLIENT_ID,
      password: CLIENT_SECRET,
    },
  });
}
export function getUnsubscribeData(type, passwordRef, token) {
  return axios({
    url: "/api/unsubsribe/tokendata",
    method: "POST",
    data: {
      type,
      passwordRef,
      token,
    },
    auth: {
      username: CLIENT_ID,
      password: CLIENT_SECRET,
    },
  });
}
export function getBlockedUsers() {
  return axios({
    url: "/api/banuser",
    method: "GET",
  });
}
export function unblockUser(userId) {
  return axios({
    url: "/api/banuser",
    method: "DELETE",
    params: {
      userId,
    },
  });
}
export function getInvitationStatus() {
  return axios({
    url: "/api/channelflags",
    method: "GET",
  });
}
export function updateInvitationStatus(status) {
  return axios({
    url: "/api/baninvitation",
    method: "PUT",
    params: {
      invitationStatus: status,
    },
  });
}
export function updateEmailChannelStatus(status) {
  return axios({
    url: "/api/emailchannel",
    method: "PUT",
    params: {
      emailStatus: status,
    },
  });
}
export function getNotes(gameId) {
  return axios({
    url: "/api/comment/findByGameId/" + gameId + "?type=NOTE",
    method: "GET",
  });
}
export function sendNote(gameId, comment) {
  return axios({
    url: "/api/comment/",
    method: "POST",
    params: {
      type: "NOTE",
      gameId,
      comment,
    },
  });
}

export function getRatingSystems() {
  return axios({
    url: "/api/rating/values",
    method: "GET",
  });
}

export function setInitialRating(sport, iplayme2Rating) {
  return axios({
    url: "/api/skill/technical/initial",
    method: "POST",
    data: { sport, iplayme2Rating },
  });
}